import { useState } from "react";
import BasicModal from "src/features/student-attendance/components/modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ScheduleEditForm from "./schedule-edit-form";
import ScheduleRidingList from "./schedule-riding-list";
import ScheduleDeleteConfirm from "./schedule-delete-confirm";
import ScheduleUpdateConfirm from "./schedule-update-confirm";

// Separate component for the Edit Button
const ScheduleEditButton = ({ schedule, selectedMonth }) => {
  const [openEditModal, setOpenEditModal] = useState(false);
  const [updatePayload, setUpdatePayload] = useState(null);

  const handleSubmit = payload => {
    setUpdatePayload({ ...payload, id: schedule.id, bus_course_id: schedule.bus_course_id });
    setOpenEditModal(false);
  };

  const handleUpdateConfirmClose = () => {
    setUpdatePayload(null);
  };

  const handleUpdateConfirmBack = () => {
    setOpenEditModal(true);
    setUpdatePayload(null);
  };

  return (
    <>
      <span>
        <button
          className="btn btn-primary w-100 btn-sm-custom"
          onClick={() => setOpenEditModal(true)}
        >
          <FontAwesomeIcon icon="edit" />
        </button>
      </span>

      {/* Edit Modal */}
      <BasicModal
        title="バススケジュール変更"
        isOpen={openEditModal}
        onCancel={() => setOpenEditModal(false)}
        width="50%"
      >
        <ScheduleEditForm
          key={schedule.id}
          selectedSchedule={schedule}
          selectedMonth={selectedMonth}
          onSubmit={handleSubmit}
          onClose={() => setOpenEditModal(false)}
        />
      </BasicModal>

      {/* Update Confirmation Modal */}
      <BasicModal
        title={`スケジュール更新の確認 - ${schedule.description}`}
        isOpen={updatePayload !== null}
        onCancel={handleUpdateConfirmClose}
        width="50%"
      >
        <ScheduleUpdateConfirm
          key={`update-confirm-${schedule.id}`}
          updatePayload={updatePayload}
          onClose={handleUpdateConfirmClose}
          onBack={handleUpdateConfirmBack}
        />
      </BasicModal>
    </>
  );
};

// Separate component for the Delete Button
const ScheduleDeleteButton = ({ schedule }) => {
  const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = useState(false);

  const handleDeleteConfirmClose = () => {
    setOpenDeleteConfirmModal(false);
  };

  return (
    <>
      <span>
        <button
          className="btn btn-danger w-100 btn-sm-custom"
          onClick={() => setOpenDeleteConfirmModal(true)}
        >
          <FontAwesomeIcon icon="trash" />
        </button>
      </span>

      {/* Delete Confirmation Modal */}
      <BasicModal
        title={`スケジュール削除の確認 - ${schedule.description}`}
        isOpen={openDeleteConfirmModal}
        onCancel={handleDeleteConfirmClose}
        width="50%"
      >
        <ScheduleDeleteConfirm
          key={`delete-confirm-${schedule.id}`}
          scheduleId={schedule.id}
          busCourseId={schedule.bus_course_id}
          onClose={handleDeleteConfirmClose}
        />
      </BasicModal>
    </>
  );
};

// Main component
const BusScheduleControls = ({ schedule, selectedMonth, showCRUDButtons }) => {
  const [openRidingListModal, setOpenRidingListModal] = useState(false);

  return (
    <div className="d-flex justify-content-center align-items-center h-100 gap-1">
      <>
        <span>
          <button
            className="btn btn-primary w-100 btn-sm-custom"
            onClick={() => setOpenRidingListModal(true)}
          >
            <FontAwesomeIcon icon="list" />
          </button>
        </span>
        <BasicModal
          title={`乗車名簿 - ${schedule.description}`}
          isOpen={openRidingListModal}
          onCancel={() => setOpenRidingListModal(false)}
          width="50%"
        >
          <ScheduleRidingList
            key={schedule.id}
            selectedSchedule={schedule}
            selectedMonth={selectedMonth}
            onClose={() => setOpenRidingListModal(false)}
          />
        </BasicModal>
      </>
      {showCRUDButtons && (
        <>
          <ScheduleEditButton schedule={schedule} selectedMonth={selectedMonth} />
          <ScheduleDeleteButton schedule={schedule} />
        </>
      )}
    </div>
  );
};

export default BusScheduleControls;
